import { render, staticRenderFns } from "./VisualizarExtincao.vue?vue&type=template&id=ad1979ac"
import script from "./VisualizarExtincao.vue?vue&type=script&lang=js"
export * from "./VisualizarExtincao.vue?vue&type=script&lang=js"
import style0 from "./VisualizarExtincao.vue?vue&type=style&index=0&id=ad1979ac&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports